import { Graphics, Matrix } from 'pixi.js';
import { app } from './../app';

const FLIPPED_HORIZONTALLY = 0x80000000;
const FLIPPED_VERTICALLY = 0x40000000;
const FLIPPED_DIAGONALLY = 0x20000000;

export class Chunk {
    constructor(chunkWidth, chunkHeight, map) {
        this.bounds = { x: 0, y: 0, width: chunkWidth, height: chunkHeight };
        this._position = { x: 0, y: 0, z: 0 };

        this.map = map;

        this.chunkWidth = chunkWidth;
        this.chunkHeight = chunkHeight;
        this.tilesWide = chunkWidth / this.map.tileWidth;
        this.tilesHigh = chunkHeight / this.map.tileHeight;
        this.tileCount = this.tilesWide * this.tilesHigh;

        this.graphics = new Graphics();

        this.hasTiles = false;
        this.inUse = false;
    }

    get mapId() {
        return this.map.id;
    }

    get x() {
        return this._position.x;
    }

    get y() {
        return this._position.y;
    }

    get z() {
        return this._position.z;
    }

    get position() {
        return this._position;
    }

    get texture() {
        return this.graphics;
    }

    set position(newPos) {
        Object.assign(this._position, newPos);
    }

    clear() {
        this.graphics.cacheAsBitmap = false;
        this.graphics.roundPixels = true;
        this.graphics.destroy();
        this.graphics = new Graphics();
    }

    render(layerSelection) {
        this.clear();
        let texIndex, tileset;
        for (let i = 0; i < layerSelection.length; i++) {
            const layer = layerSelection[i];

            for (let j = 0; j < this.tileCount; j++) {
                // Chunk tile !== tile.
                // Position of chunk tile in chunk.
                const chunkTileX = j % this.tilesWide;
                const chunkTileY = Math.floor(j / this.tilesWide);

                // Position of chunk tile in map.
                const mapX = (this.position.x * this.tilesWide) + chunkTileX;
                const mapY = (this.position.y * this.tilesHigh) + chunkTileY;

                if (mapX < 0 || mapX >= this.map.width ||
                    mapY < 0 || mapY >= this.map.height)
                    continue;

                // Convert our x and y to an index to look at in the layer.
                const layerIndex = mapX + mapY * this.map.width;

                // Check we have a valid index.
                texIndex = layerIndex < layer.data.length ? layer.data[layerIndex] : 0;
                if (!texIndex)
                    continue;

                // Check for rotated tile.
                let isHorizontal = (texIndex & FLIPPED_HORIZONTALLY);
                let isVertical = (texIndex & FLIPPED_VERTICALLY);
                let isDiagonal = (texIndex & FLIPPED_DIAGONALLY);
                texIndex &= ~(FLIPPED_HORIZONTALLY | FLIPPED_VERTICALLY | FLIPPED_DIAGONALLY);

                // Find the correct tileset.
                for (let k = 0; k < this.map.tilesets.length; k++) {
                    tileset = this.map.tilesets[k];
                    if (texIndex >= tileset.firstId && texIndex <= tileset.lastId) break;
                    else tileset = 0;
                }

                // Check if we have a tileset for the index.
                if (!tileset)
                    continue;

                this.hasTiles = true;
                texIndex--;
                const targetX = Math.floor(chunkTileX * tileset.tileWidth);
                const targetY = Math.floor(chunkTileY * tileset.tileHeight);

                this.renderGraphics(tileset.tiles[texIndex], targetX, targetY, tileset.tileWidth, tileset.tileHeight, isHorizontal, isVertical, isDiagonal);
            }

            this.graphics.x = this._position.x * this.chunkWidth;
            this.graphics.y = this._position.y * this.chunkHeight;
            //this.graphics.anchor.set(0.5);
            if (!app.performanceManager.dontUseBitmaps){
                this.graphics.cacheAsBitmap = true;
            }
            //this.graphics.visible = true;
        }
        return this.sprite || this.graphics;
    }

    renderGraphics(texture, targetX, targetY, tileWidth, tileHeight, isHorizontal, isVertical, isDiagonal) {
        let matrix = Matrix.IDENTITY;
        if (isDiagonal) {
            matrix.rotate((Math.PI * 3) / 2);
            matrix.scale(1, -1);
        }
        if (isHorizontal) matrix.scale(-1, 1);
        if (isVertical) matrix.scale(1, -1);

        this.graphics.beginTextureFill(texture, 0xFFFFFF, 1, matrix);
        this.graphics.drawRect(targetX, targetY, tileWidth, tileHeight);
        this.graphics.endFill();
    }

    /*     renderCanvas(texture, texX, texY, targetX, targetY, tileWidth, tileHeight, isHorizontal, isVertical, isDiagonal) {
            if (isHorizontal) {
                this.context.translate(texture.width + texX, 0);
                this.context.scale(-1, 1);
            } else if (isVertical) {
                this.context.translate(0, texture.height + texY);
                this.context.scale(1, -1);
            } else if (isDiagonal) {
                this.context.translate(texture.width + texX, texture.height + texY);
                this.context.scale(-1, -1);
            }

            this.context.drawImage(texture,
                texX, texY, tileWidth, tileHeight,
                targetX, targetY, tileWidth, tileHeight);

            // Reset
            this.context.setTransform(1, 0, 0, 1, 0, 0);

            this.texture.update();

            this.sprite.x = this.mapPos.x * this.chunkWidth;
            this.sprite.y = this.mapPos.y * this.chunkHeight;
            this.sprite.anchor.set(0.5);
            this.sprite.visible = true;
        } */
}
